import { negateVariable, theme } from '../theme';
export const NODE_DIMENSION = 80;
export const TILE_NODE_HEIGHT = 74;
export const TILE_NODE_WIDTH = 266;
export const GRID_SIZE = NODE_DIMENSION / 4;
export const DEFAULT_ZOOM_LEVEL = 1 / 1.2;
export const SUBFLOW_EXPAND_NODE_DIM = 200;
export const SUBFLOW_MARGIN = 60;
export const NODE_SPACING = 120;
export const LABEL_HEIGHT = 20;
export const COMMENT_NODE_MIN_WIDTH = 220;
export const COMMENT_NODE_MIN_HEIGHT = 45;
export const COMMENT_NODE_PLACEHOLDER = 'Type something';
export const COMMENT_NODE_SPACING = 45;
export const EDGE_EDGE_SPACING = 30;
export const EDGE_NODE_SPACING = 30;
export const PORT_PORT_SPACING = 20;
export const GRAPH_ROOT_CLASS = 'ui-graph-root';
export const REACT_FLOW_CLASS = 'react-flow';
export const REACT_FLOW_PANE = 'react-flow__pane';
export const LEFT_HANDLE_CLASS = 'react-flow__handle-left';
export const RIGHT_HANDLE_CLASS = 'react-flow__handle-right';
export const REACT_FLOW_HANDLE = 'react-flow__handle';
export const REACT_FLOW_CONNECTION_PATH = 'react-flow__connection-path';
export const REACT_FLOW_EDGE_PATH = 'react-flow__edge-path';
export const REACT_FLOW_EDGE = 'react-flow__edge';
export const REACT_FLOW_EDGES = 'react-flow__edges';
export const CONNECTION_GROUP_SUFFIX = '-connection-group';
export const REACT_FLOW_CONTROLS = 'react-flow__controls';
export const REACT_FLOW_MINIMAP = 'react-flow__minimap';
export const REACT_FLOW_NODESSELECTION_RECT = 'react-flow__nodesselection-rect';
export const REACT_FLOW_HANDLE_CONNECTING = 'react-flow__handle-connecting';
export const REACT_FLOW_HANDLE_VALID = 'react-flow__handle-valid';
export const REACT_FLOW_ATTRIBUTION = 'react-flow__attribution';
export const REACT_FLOW_SELECTED = 'selected';
export const REACT_FLOW_NODE = 'react-flow__node';
export const REACT_FLOW_NODE_SUBFLOW = 'react-flow__node-subFlow';
export const REACT_FLOW_SELECTION_PANE = 'react-flow__selectionpane';
export const HIGHLIGHTED_NODE_HANDLE = 'highlight-node-handle';
/** Out of range position value to trigger auto position */ export const AUTO_POSITION = 2147483600;
export const GEM_NODE_CONTAINER = 'gem-node-container';
export const GEM_NODE_WRAPPER = 'gem-node-wrapper';
export const REACT_FLOW_SOURCE_HANDLE_KEY = 'source';
export const ADD_NEW_PORT_HANDLE = 'add-new-port-handle';
export const ADD_NEW_PORT_HANDLE_ID = 'new-port-id';
export const REACT_FLOW_CONNECTION_LINE = 'react-flow__connectionline';
export const VALID_GEM_CONNECTION = 'valid-gem-connection';
export const INVALID_GEM_CONNECTION = 'invalid-gem-connection';
export const OUTER_NODE_WRAPPER_CLASS = 'outer-node-wrapper';
export const NODE_HOVERED = 'node-hovered';
export const SUBFLOW_NODE_WRAPPER_CLASS = 'subflow-node-wrapper';
export const DRAGGING_SUBFLOW_CLASS = 'dragging-subflow';
export const tokens = {
    Tile: {
        width: `${TILE_NODE_WIDTH}px`,
        height: `${TILE_NODE_HEIGHT}px`,
        transition: theme.transition.m
    },
    Node: {
        height: `${NODE_DIMENSION}px`,
        width: `${NODE_DIMENSION}px`,
        background: theme.colors.white,
        borderRadius: theme.radius.x12,
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: theme.colors.grayBlue300,
        Label: {
            gap: theme.spaces.x4
        },
        state: {
            selected: {
                borderWidth: '3px',
                borderColor: theme.colors.brand500,
                shadow: theme.shadows.xl
            },
            dragging: {
                borderWidth: '2px',
                borderStyle: 'dashed',
                borderColor: theme.colors.brand500
            },
            error: {
                borderColor: theme.colors.error500
            },
            warning: {
                borderColor: theme.colors.warning500
            },
            created: {
                borderColor: theme.colors.success400,
                borderWidth: '2px'
            },
            modified: {
                borderColor: theme.colors.yellow300,
                borderWidth: '2px'
            },
            lineageModified: {
                borderColor: theme.colors.yellow400,
                borderWidth: '2px'
            },
            lineageUnmodified: {
                borderColor: theme.colors.success400,
                borderWidth: '2px'
            }
        },
        hover: {
            shadow: theme.shadows.md
        },
        NodeContainer: {
            padding: '5px',
            gap: '3px',
            borderRadius: '9px'
        },
        dragging: {
            zIndex: 3
        }
    },
    Selection: {
        border: `1px dashed ${theme.colors.brand500}`,
        padding: theme.spaces.x24,
        transformX: `${negateVariable(theme.spaces.x24)}`,
        transformY: `${negateVariable(theme.spaces.x24)}`
    },
    Connection: {
        Label: {
            borderRadius: theme.radius.x4,
            background: theme.colors.brand50
        },
        Path: {
            strokeWidth: theme.spaces.x2,
            stroke: theme.colors.grayBlue200
        },
        state: {
            selected: {
                stroke: theme.colors.brand500
            },
            virtual: {
                stroke: theme.colors.grayBlue200
            },
            created: {
                stroke: theme.colors.success400,
                strokeWidth: theme.spaces.x2
            },
            modified: {
                stroke: theme.colors.yellow300,
                strokeWidth: theme.spaces.x2
            },
            lineageModified: {
                stroke: theme.colors.yellow400,
                strokeWidth: theme.spaces.x2
            },
            lineageUnmodified: {
                stroke: theme.colors.success400,
                strokeWidth: theme.spaces.x2
            }
        },
        dragging: {
            zIndex: 4
        }
    },
    Controls: {
        Icon: {
            borderRadius: theme.radius.x4,
            state: {
                hover: {
                    background: theme.colors.brand500,
                    color: theme.colors.white
                }
            }
        }
    },
    Status: {
        Pass: {
            borderColor: theme.colors.success400,
            color: theme.colors.success500
        },
        Modify: {
            borderColor: theme.colors.warning400,
            color: theme.colors.warning500
        },
        Absent: {
            borderColor: theme.colors.grayBlue300,
            color: theme.colors.grayBlue500
        }
    },
    ExtenderEdge: {
        Line: {
            borderColor: theme.colors.grayBlue200
        }
    }
};
